import { useEffect, useState } from "react";

const InternshipPage = () => {
  const [internshipApplications, setInternshipApplications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("token");

  // Fetch data from the API
  const fetchApplications = async () => {
    try {
      const response = await fetch(
        "https://admindashboard.clns.in/api/dashboard/advocate_status/",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setInternshipApplications(data.advocates);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleAction = async (id, newStatus, lawyerName) => {
    setIsLoading(true);
    const payload = {
      advocate_id: id,
      advocate_status: newStatus,
    };

    try {
      const response = await fetch(
        "https://admindashboard.clns.in/api/dashboard/advocate_status/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      // Check if the response is OK and if there's a success message
      if (response.ok && data.message && data.message.includes("successfully")) {
        // Alert the user of the action taken
        alert(`Status updated for ${lawyerName}: ${getStatusText(newStatus)}`);
        
        // Refresh the data from the API
        await fetchApplications();
      } else {
        console.error("Failed to update status:", data.message || "No message provided");
        alert("Failed to update status. Please try again.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred while updating the status.");
    } finally {
      setIsLoading(false);
    }
  };

  // Function to get status text
  const getStatusText = (status) => {
    switch (status) {
      case 0:
        return "Applied";
      case 1:
        return "Accepted";
      case 2:
        return "Rejected";
      default:
        return "Unknown";
    }
  };

  return (
    <>
      <div style={{ fontSize: "20px", marginBottom: "10px" }}>
        Lawyer Registration
      </div>
      <style>{`
        table {
          width: 90%;
          border-collapse: collapse;
          margin: 0 auto;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        }
        th,
        td {
          border: 1px solid #ddd;
          padding: 12px 16px;
          text-align: left;
        }
        th {
          background-color: #1976d2;
          color: white;
          font-weight: bold;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        img {
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 50%;
        }
        button {
          margin-right: 5px;
          padding: 5px 15px;
          border: 2px solid;
          border-radius: 20px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
        }
        button.accept {
          border-color: #4caf50;
          color: #4caf50;
          background-color: transparent;
        }
        button.accept:hover:not([disabled]) {
          background-color: #4caf50;
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 2px 5px rgba(76, 175, 80, 0.3);
        }
        button.accept:active:not([disabled]) {
          transform: translateY(0);
          box-shadow: none;
        }
        button.reject {
          border-color: #f44336;
          color: #f44336;
          background-color: transparent;
        }
        button.reject:hover:not([disabled]) {
          background-color: #f44336;
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 2px 5px rgba(244, 67, 54, 0.3);
        }
        button.reject:active:not([disabled]) {
          transform: translateY(0);
          box-shadow: none;
        }
        button[disabled] {
          background-color: #f1f1f1;
          color: #888;
          border-color: #ddd;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        .highlight {
          border: 2px solid #4caf50;
          border-radius: 8px;
        }
        .status {
          padding: 6px 12px;
          border-radius: 20px;
          font-weight: 500;
          display: inline-block;
          text-align: center;
        }
        .status-applied {
          background-color: #fff3e0;
          color: #ff9800;
        }
        .status-accepted {
          background-color: #e8f5e9;
          color: #4caf50;
        }
        .status-rejected {
          background-color: #ffebee;
          color: #f44336;
        }
        .button-group {
          display: flex;
          gap: 8px;
        }
      `}</style>
      <table>
        <thead>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Bar Code</th>
            <th>Court</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {internshipApplications?.map((app, index) => (
            <tr key={index} className={index === 0 ? "highlight" : ""}>
              <td>
                {app.profile_image ? (
                  <img src={app.profile_image} alt={app.first_name} />
                ) : (
                  "No Image"
                )}
              </td>
              <td>
                {app.first_name} {app.last_name}
              </td>
              <td>{app.barcode_id}</td>
              <td>{app.court}</td>
              <td>
                <span className={`status status-${getStatusText(app.status).toLowerCase()}`}>
                  {getStatusText(app.status)}
                </span>
              </td>
              <td>
                <div className="button-group">
                  <button
                    className="accept"
                    onClick={() => handleAction(app.id, 1, `${app.first_name} ${app.last_name}`)}
                    disabled={app.status === 1 || isLoading}
                  >
                    Accept
                  </button>
                  <button
                    className="reject"
                    onClick={() => handleAction(app.id, 2, `${app.first_name} ${app.last_name}`)}
                    disabled={app.status === 2 || isLoading}
                  >
                    Reject
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default InternshipPage;
